export default __webpack_public_path__ + "static/media/banner1.0495fc34.png";